import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { createConnector, InferConnectedProps } from '../../../redux/createConnector'
import { onlineUserIds } from '../../../redux/presence/selectors'
import UserPresenceAvatar, { IProps } from './UserPresenceAvatar'

const selector = createStructuredSelector({
  onlineUserIds,
})
const connector = connect(selector)
// `{}` for the actions arg — the repo's convention for a selector-only connector.
// eslint-disable-next-line @typescript-eslint/no-empty-object-type -- matches every other action-less connector
export type PropsFromRedux = InferConnectedProps<typeof connector, {}>
export default createConnector<typeof connector, IProps, PropsFromRedux>(
  connector,
  UserPresenceAvatar,
)
